export default __webpack_public_path__ + "media/src/assets/images/Trash-b5facf41c5b0d44805836de839f023fe.svg";